import { render, staticRenderFns } from "./ToxicChemicalList.vue?vue&type=template&id=8509087a&"
import script from "./ToxicChemicalList.vue?vue&type=script&lang=js&"
export * from "./ToxicChemicalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports